import { useEffect } from 'react';

const usePageTitle = (title: string, restorePrev = false) => {
  useEffect(() => {
    const prevTitle = document.title;
    const newTitle = '99minutos - ' + title;
    document.title = newTitle;

    return () => {
      if (restorePrev) {
        document.title = prevTitle;
      }
    };
  }, [title, restorePrev]);
};

export default usePageTitle;
